import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
var _hoisted_1 = { class: "content-layout-detail" };
var _hoisted_2 = { class: "head-left-content" };
var _hoisted_3 = {
    key: 1,
    class: "flex-center edit-mode-title"
};
var _hoisted_4 = { class: "page-title" };
var _hoisted_5 = { class: "head-tool-bar" };
import DarkThemeModeSelector from "@/components/custom/DarkThemeModeSelector.vue";
import FullScreenBtn from "@/components/common/FullScreenBtn.vue";
import ConfigBtn from "@/components/custom/ConfigBtn.vue";
import TopPersonalBtn from "@/components/custom/TopPersonalBtn.vue";
import MenuToggler from "../outter/menu-toggler.vue";
import { useStore } from "@/store";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { headIcon } from "@/utils/constants";
export default /*@__PURE__*/ _defineComponent({
    __name: 'HeadRightToolBar',
    setup: function (__props) {
        var store = useStore();
        var route = useRoute();
        var isReplaceFolderBtnWithTerminalIcon = computed(function () { return route.path.startsWith("/edit") || route.path.startsWith("/backup"); });
        return function (_ctx, _cache) {
            var _component_n_tooltip = _resolveComponent("n-tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (!isReplaceFolderBtnWithTerminalIcon.value)
                        ? (_openBlock(), _createBlock(MenuToggler, {
                            key: 0,
                            collapsed: _unref(store).isMenuCollapsed,
                            onClick: _cache[0] || (_cache[0] = function ($event) { return (_unref(store).toggleMenuCollapse()); })
                        }, null, 8, ["collapsed"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(headIcon))))
                        ])),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(store).pageName), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                        trigger: _withCtx(function () { return [
                            _createVNode(DarkThemeModeSelector, {
                                size: "35",
                                initial: _unref(store).isDarkTheme,
                                onClick: _cache[1] || (_cache[1] = function ($event) { return (_unref(store).switchDarkTheme()); }),
                                style: { "margin-right": "0.8rem" }
                            }, null, 8, ["initial"])
                        ]; }),
                        default: _withCtx(function () { return [
                            _createTextVNode(_toDisplayString(_unref(store).isDarkTheme ? "切换为亮色" : "切换为暗色"), 1)
                        ]; }),
                        _: 1
                    }),
                    _createVNode(FullScreenBtn),
                    _createVNode(ConfigBtn),
                    _createVNode(TopPersonalBtn)
                ])
            ]));
        };
    }
});
